import React from "react";
import PropTypes from "prop-types";
import { Skeleton } from "primereact/skeleton";
import Layout from "~/Layout";
import RequestDetailsSidebar from "./components/RequestDetailsSidebar";
import { REQUEST_TYPES } from "../useRequest";

const RequestLayout = ({ children, requestData, loading, requestType }) => {
  const breadcrumbs =
    requestType === REQUEST_TYPES.AD_HOC
      ? [
          { label: "Request", url: "/requests" },
          {
            label: (
              <div className="flex">
                {!loading ? (
                  <>{`#${requestData?.request_id}`}</>
                ) : (
                  <Skeleton width="100px" height="20px" className="mr-1" />
                )}
              </div>
            ),
            id: "requests",
          },
        ]
      : [
          { label: "Escalation", url: "/escalations" },
          {
            label: (
              <div className="flex">
                {!loading ? (
                  <>{requestData?.request_id}</>
                ) : (
                  <Skeleton width="100px" height="20px" className="mr-1" />
                )}
              </div>
            ),
            id: "escalations",
          },
        ];
  return (
    <Layout
      crumbs={breadcrumbs}
      SideNavSection={() => {
        return (
          <div className="sidenav-process">
            <div className="process-sidebar-container">
              <div className="sidebar-milestones-container">
                <div className="details">
                  <p className="sidebar-milestones-label">Details</p>
                  <RequestDetailsSidebar
                    data={requestData}
                    loading={loading}
                    requestType={requestType}
                  />
                </div>
              </div>
            </div>
          </div>
        );
      }}
      hideScrollbar={true}
    >
      {children}
    </Layout>
  );
};

RequestLayout.propTypes = {
  children: PropTypes.node.isRequired,
  requestData: PropTypes.object,
  loading: PropTypes.bool,
  requestType: PropTypes.string,
};
export default RequestLayout;
